;(function () {
    function PlzSearchController() {
        var input = document.querySelector('.plz-search__input')
        var listItems = document.querySelectorAll('.plz-search li')
        var noResults = document.querySelector('.plz-search .no-results')

        if (!input || !listItems.length) return

        input.addEventListener('input', function () {
            var search = input.value.trim()

            // Field cleared → show all entries, hide no-results
            if (search.length === 0) {
                listItems.forEach(function (li) {
                    li.classList.remove('hidden')
                })
                if (noResults) noResults.classList.add('hidden')
                return
            }

            // Filter entries by PLZ prefix match
            var hasVisibleItems = false
            listItems.forEach(function (li) {
                var plzList = (li.dataset.plz || '')
                    .split(',')
                    .map(function (plz) {
                        return plz.trim()
                    })
                    .filter(Boolean)

                var match = plzList.some(function (plz) {
                    return plz.startsWith(search)
                })

                if (match) {
                    li.classList.remove('hidden')
                    hasVisibleItems = true
                } else {
                    li.classList.add('hidden')
                }
            })

            // No results found → show no-results message
            if (noResults) {
                if (!hasVisibleItems) {
                    noResults.classList.remove('hidden')
                } else {
                    noResults.classList.add('hidden')
                }
            }
        })
    }

    if (document.readyState !== 'loading') {
        PlzSearchController()
    } else {
        document.addEventListener('DOMContentLoaded', PlzSearchController)
    }
})()
